module.exports = __webpack_public_path__ + "img/homepage.a8c86bd6.jpg";